import { render, staticRenderFns } from "./AllAnnualReturnsSubmissions.vue?vue&type=template&id=f3ddde3a&scoped=true&"
import script from "./AllAnnualReturnsSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllAnnualReturnsSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllAnnualReturnsSubmissions.vue?vue&type=style&index=0&id=f3ddde3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ddde3a",
  null
  
)

export default component.exports